export enum ReferralType {
  notSet = 'NotSet',
  autovitals = 'Autovitals',
  protractor = 'Protractor'
}
